<template>
  <div>
    <div style=" pointer-events: none;">
      <h5 v-html="(active+1) +'.'+ data[active].examcont +'（'+ data[active].scores+'分）' "></h5>
      <van-radio-group  >
        <van-radio
          v-for="(m,n) in data[active].examop"
          :key="m.optionid+''"
          :name="m.optionid+''"
        >
          <span  v-html="capital[n]+'.&nbsp&nbsp'+m.optioncontent" ></span>
        </van-radio>
      </van-radio-group>
    </div>
    <!--正确答案题目解析-->
    <div  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in data[active].examan" v-html="a.optioncontent"></a> </div>
    <div  style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="data[active].gradestand"></a> </div>
    <div style="height: 100px;width: 100%" ></div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      radio: '',
      capital: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/teacherpage/cuotijicomm/trueOrFalse.vue